import script from "./custStandardMan.vue?vue&type=script&setup=true&lang=ts"
export * from "./custStandardMan.vue?vue&type=script&setup=true&lang=ts"

import "./custStandardMan.vue?vue&type=style&index=0&id=47b9244e&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47b9244e"]])

export default __exports__